import React, { Component } from 'react'
import zhihuHybrid from 'zhihu-hybrid'
import throttle from 'lodash.throttle'
import cx from 'classnames'

import { universalDispatch, formatNumber } from '../../utils'
import IdeaItem from '../IdeaItem'
import styles from './index.css'
import { getIdeaByDynId } from '../../services'

const initialState = {
  isLoading: false,
  showIdeaButton: false,
  pageNum: 1, // 想法列表当前所在的页数，初始化为1
  pageSize: 10,
  totalCount: 0,
  ideaList: [],
  isEndPage: false,
  isAddIdea: false,
}

const parseContent = content => {
  const contentList = JSON.parse(content)
  const result = {
    hasImage: false,
    hasVideo: false,
    hasLink: false,
    text: '',
    imgList: [],
    linkUrls: [],
    video: {
      videoUrl: '',
      cover: '',
      videoId: '',
    },
  }
  contentList.forEach(item => {
    switch (item.type) {
      case 'text':
        result.text = item.content
        break
      case 'image':
        result.hasImage = true
        result.imgList.push(item.url)
        break
      case 'video':
        result.hasVideo = true
        result.video = {
          title: '知乎视频',
          bannerType: 0,
          videoId: item.video_id,
          videoUrl: `https://v.vzuu.com/video/${item.video_id}`,
          cover: item.thumbnail,
        }
        break
      case 'link':
        result.hasLink = true
        result.linkUrls.push(item.url)
        break
      default:
        break
    }
  })
  return result
}
export default class IdeaList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...initialState,
    }
  }

  componentDidMount() {
    this.loadData()
    window.addEventListener('scroll', throttle(this.handleScroll, 1000))
  }

  componentWillReceiveProps(nextProps) {
    const thisProps = this.props
    if (thisProps.dynamicId !== nextProps.dynamicId) {
      this.setState(
        {
          ...initialState,
        },
        this.loadData
      )
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', throttle(this.handleScroll, 1000))
  }

  loadData = () => {
    const { dynamicId } = this.props
    const { isLoading, isEndPage, totalCount } = this.state
    if (!dynamicId || isLoading) return

    const { pageSize, pageNum, ideaList } = this.state
    this.setState({
      isLoading: true,
      isAddIdea: false,
    })

    getIdeaByDynId({
      dynamicId,
      pageNum,
      pageSize,
    })
      .then(({ data } = {}) => {
        this.setState({
          isLoading: false,
        })
        const { totalCount: newTotalCount, data: newIdeaList } = data
        if (
          newIdeaList.length === 0 ||
          (isEndPage && newTotalCount === totalCount)
        )
          return
        // 解析想法content, 过滤掉未返回Video ID 的视频
        const handleIdealist = newIdeaList
          .map(item => ({
            ...item,
            content: parseContent(item.content),
          }))
          .filter(
            item => !(item.content.hasVideo && !item.content.video.videoId)
          )

        let allIdeas = []
        if (isEndPage && newTotalCount !== totalCount) {
          allIdeas = ideaList
            .splice(0, pageNum * pageSize)
            .concat(handleIdealist)
        } else {
          allIdeas = ideaList.concat(handleIdealist)
        }
        const setIsEndPage = pageNum * pageSize > newTotalCount
        this.setState({
          totalCount: newTotalCount,
          ideaList: allIdeas,
          pageNum: setIsEndPage ? pageNum : pageNum + 1,
          isEndPage: setIsEndPage,
        })
      })
      .catch(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  handleScroll = () => {
    const { isLoading, isAddIdea } = this.state
    if (isLoading || !this.ideaCard) {
      return
    }
    const ideaCardHeight = this.ideaCard.clientHeight
    const { scrollHeight, clientHeight, scrollTop } = document.body
    const toBottomHeight =
      scrollHeight -
      clientHeight -
      (document.documentElement.scrollTop || scrollTop)

    this.isShowIdeaButton(ideaCardHeight, toBottomHeight)
    if (toBottomHeight < 60 || isAddIdea) {
      this.loadData()
    }
  }

  isShowIdeaButton = (ideaCardHeight, toBottomHeight) => {
    const { showIdeaButton } = this.state
    if (ideaCardHeight - toBottomHeight > 46 && !showIdeaButton) {
      this.setState({
        showIdeaButton: true,
      })
    }
    if (ideaCardHeight - toBottomHeight < 46 && showIdeaButton) {
      this.setState({
        showIdeaButton: false,
      })
    }
  }

  addIdea = () => {
    if (!this.state.showIdeaButton) return
    const { dynamicId } = this.props
    this.setState({
      isAddIdea: true,
    })
    universalDispatch(() => {
      zhihuHybrid.dispatch('commercial/writePin', {
        business_type: 'activity-pin',
        business_id: dynamicId,
      })
    })
  }

  render() {
    const { totalCount, ideaList, showIdeaButton } = this.state
    const { organizationName } = this.props
    return (
      <div
        ref={node => {
          this.ideaCard = node
        }}
      >
        <div className={styles.IdeaListHead}>
          <div className={styles.Title}>全部讨论</div>
          <div className={styles.Count}>{formatNumber(totalCount)}个回答</div>
        </div>
        {ideaList.length > 0 &&
          ideaList.map(item => (
            <IdeaItem key={item.pinId} data={{ ...item, organizationName }} />
          ))}
        {ideaList.length === 0 && (
          <div className={styles.EmptyPage}>尚无讨论，快来参与！</div>
        )}
        <div
          className={cx(styles.IdeaBtn, styles.Hidden, {
            [styles.Show]: showIdeaButton,
          })}
          onClick={this.addIdea}
        >
          参与讨论
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/IdeaList/index.js